export class HttpRequestError extends Error {
  public constructor(status: number, statusText: string) {
    super();
    return new Error(`Network call is not OK. ${status} ${statusText}`);
  }
}
